import React from 'react';
import {useField} from 'formik';
import Input from '@material-ui/core/Input';

export const MyTextInput = ({ label, type, inputProps, ...props }) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    const [field, meta] = useField({ type, inputProps, ...props });
    const mergedInputProps =
        type === 'number'
            ? {
                ...inputProps,
                onWheel: (e) => {
                    if (inputProps?.onWheel) {
                        inputProps.onWheel(e);
                    }
                    e.preventDefault();
                },
            }
            : inputProps;
    return (
        <div className="form-group fv-plugins-icon-container">
            <label htmlFor={props.id || props.name}>{label}</label>
            <Input className={`form-control form-control-solid h-auto py-2 px-6 text-dark`}
                   {...field} {...props} type={type} inputProps={mergedInputProps} />
            {meta.touched && meta.error ? (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{meta.error}</div>
                </div>
            ) : null}
        </div>
    );
};

export const TableInput = ({ label, type, inputProps, ...props }) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and also replace ErrorMessage entirely.
    const [field, meta] = useField({ type, inputProps, ...props });
    const mergedInputProps =
        type === 'number'
            ? {
                ...inputProps,
                onWheel: (e) => {
                    if (inputProps?.onWheel) {
                        inputProps.onWheel(e);
                    }
                    e.preventDefault();
                },
            }
            : inputProps;
    return (
        <div className="form-group fv-plugins-icon-container">
            <Input className={`form-control h-auto py-2 px-6 text-dark`}
                   {...field} {...props} type={type} inputProps={mergedInputProps} />
            {meta.touched && meta.error ? (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{meta.error}</div>
                </div>
            ) : null}
        </div>
    );
};


